/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import img_Info from "../image/img_info_ssms.png";
import Logo_Linkcampus from "../image/Logo_Linkcampus.png";

import {
  default as Apply_Modal,
  default as Apply_Modal2,
} from "../Component/Apply_Modal";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import Footer_SSMS from "./Footer_SSMS";
import Side_SSMS from "./Side_SSMS";
const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 85px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  padding: 10px;
  @media (max-width: 800px) {
    padding: 0px;
  }
`;
const Header_div = styled.div`
  display: flex;
  color: black;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  padding: 15px 20px;
`;
const Logo_img = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
  margin-right: 50px;
  height: 40px;
  @media (max-width: 800px) {
    margin-right: 30px;
    height: 20px;
  }
`;
const Top_Button = styled.span`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  font-size: 20px;
  margin-left: 30px;
  cursor: pointer;
  color: #c0c0c0;
  transition: color 0.2s ease;
  &:hover {
    color: black;
  }
  @media (max-width: 800px) {
    font-size: 12px;
    margin-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 850px;
  justify-self: center;
  @media (max-width: 800px) {
    width: 90%;
  }
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const Footer_Bar = styled.div`
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  width: 1280px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const Footer_div = styled.div`
  justify-self: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 20%;
  @media (max-width: 800px) {
    width: 40%;
  }
`;
const Footer_Text2 = styled(Content_Text)`
  transition: color 0.2s ease;

  &:hover {
    color: #33cccc;
  }
`;

const UnderLine = styled.div`
  position: absolute;
  bottom: 0px;
  width: 70px;
  height: 2px;
  background-color: black;
  @media (max-width: 800px) {
    width: 41px;
    height: 1px;
  }
`;
function Info_SSMS() {
  const navigation = useNavigate();
  const [stan_modal, set_Stan_Modal] = useState(false);
  const [pre_modal, set_Pre_Modal] = useState(false);
  const close_Stan_Modal = () => set_Stan_Modal(false);
  const close_Pre_Modal = () => set_Pre_Modal(false);
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const open_privacy_policy = () => set_Privacy_Policy(true);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const open_terms = () => set_Terms(true);
  const close_terms = () => set_Terms(false);
  const go_Home = () => {
    navigation("/SSMS/");
    window.scrollTo({ top: 0 });
  };
  const go_About = () => {
    navigation("/SSMS/about");
    window.scrollTo({ top: 0 });
  };
  // eslint-disable-next-line no-unused-vars
  const go_Platform = () => {
    navigation("/SSMS/Platform");
    window.scrollTo({ top: 0 });
  };
  const go_Info = () => {
    navigation("/SSMS/Info");
    window.scrollTo({ top: 0 });
  };
  const go_Process = (item) => {
    navigation("/SSMS/Process_SSMS");
    window.scrollTo({ top: 0 });
  };
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // 사이즈 체크
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_div>
          <Logo_img
            onClick={() => {
              go_Home();
            }}
            src={Logo_Linkcampus}
            alt={Logo_Linkcampus}
          />
          <Top_Button
            onClick={() => {
              go_Info();
              window.scrollTo({ top: 0 });
            }}
            style={{ color: "black" }}
          >
            회사소개
            <UnderLine />
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_Process();
            }}
          >
            프로세스
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_Platform();
            }}
          >
            플랫폼
          </Top_Button>
          <Top_Button
            onClick={() => {
              go_About();
              window.scrollTo({ top: 0 });
            }}
          >
            제작문의
          </Top_Button>
        </Header_div>
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                회사소개
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div>
          <Main_init_div>
            <Main_Content>
              <Image src={img_Info} />
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Side_SSMS />
      </Main>
      <Footer>
        <Footer_SSMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
      <Apply_Modal show={stan_modal} onClose={close_Stan_Modal} data={"stan"} />
      <Apply_Modal2 show={pre_modal} onClose={close_Pre_Modal} data={"pre"} />
    </Container>
  );
}

export default Info_SSMS;
